import { render } from "./MyOrders.vue?vue&type=template&id=b0749d40&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=ts"
export * from "./MyOrders.vue?vue&type=script&lang=ts"

import "./MyOrders.vue?vue&type=style&index=0&id=b0749d40&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b0749d40"

export default script